import { render } from "./component.vue?vue&type=template&id=36f8127f&scoped=true"
const script = {}

import "./component.vue?vue&type=style&index=0&id=36f8127f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f8127f"]])

export default __exports__